export default "__VITE_ASSET__Cczw$7kn__"